// extracted by mini-css-extract-plugin
export default {"cartItem":"cart-item___gTvpp","cartItemDetails":"cart-item-details___uksFt"};